import { render, staticRenderFns } from "./journals.vue?vue&type=template&id=d1a4abb8&"
import script from "./journals.vue?vue&type=script&lang=js&"
export * from "./journals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports